import { SharedConstants } from "../../../../../shared/constants/shared.constants";
export class ViewApplicationLocationMndConstants {
    static STEP_TITLE = "Location";
    static SAVE_BUTTON_PLACEHOLDER = SharedConstants.SAVE_LABEL;
    static LOCATION_HEADING_LABEL = "Location details";
    static REGION_LABEL = "Region Name";
    static AREA_LABEL = "Area Name";
    static WPU_LABEL = "Work Plan Unit Name";
    static PLANTATION_LABEL = "Plantation Name";
    static COMPARTMENT_LABEL = "Compartment Name";
    static REGION_FORM_CONTROL_NAME = "region";
    static AREA_FORM_CONTROL_NAME = "area";
    static WPU_FORM_CONTROL_NAME = "wpu";
    static PLANTATION_FORM_CONTROL_NAME = "plantation";
    static COMPARTMENT_FORM_CONTROL_NAME = "compartment";
    static MODAL_OPTION = {
        size: SharedConstants.MODAL_SIZE.extraLarge,
        centered: true,
        backdrop: "static",
        keyboard: false
    };
    static DESCRIPTION_LABEL_1 = "Search the map to find the property for which you are lodging an application, using the 'Find address or place' search bar.";
    static DESCRIPTION_LABEL_2 = "Zoom in close enough to the correct property and click on the property. Click on 'add property' in the window that appears on the map after you selected the property.";
    static DESCRIPTION_LABEL_3 = "The property will be added and the fields must be completed for the property. Please note that multiple properties may be added.";
    static DESCRIPTION_LABEL_4 = "Please note that the zoning here is the current zoning of the property. Please note that an owner should be added for each property (this is linked to the property and the application).";
    static VALIDATION_MESSAGES = {
        region: {
            required: `Region ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        area: {
            required: `Area ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        wpu: {
            required: `Work Plan Unit ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        plantation: {
            required: `Plantation ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        compartment: {
            required: `Compartment ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }
    };
}
